import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const DEVICES = {
  desktop: { label: 'Desktop', width: '100%'  },
  tablet:  { label: 'Tablet',  width: '820px' },
  mobile:  { label: 'Mobile',  width: '390px' },
};

export default function AdminLandingPreviewPage() {
  const { user, loading } = useAuth();
  const [device, setDevice] = useState('desktop');
  const [reloadKey, setReloadKey] = useState(0);

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'Admin') return <Navigate to="/" replace />;

  // ?guest=1 tells AuthProvider inside the iframe to behave as a signed-out visitor
  const src = `/?guest=1`;

  const dev = DEVICES[device];

  return (
    <div style={s.wrap}>
      <div style={s.toolbar}>
        <div style={s.toolbarGroup}>
          {Object.entries(DEVICES).map(([key, d]) => (
            <button
              key={key}
              type="button"
              onClick={() => setDevice(key)}
              style={{ ...s.pill, ...(device === key ? s.pillActive : {}) }}
            >
              {d.label}
            </button>
          ))}
        </div>

        <button type="button" onClick={() => setReloadKey(k => k + 1)} style={s.refreshBtn}>
          ⟳ Refresh
        </button>

        <a href={src} target="_blank" rel="noopener noreferrer" style={s.refreshBtn}>
          ↗ Open in new tab
        </a>
      </div>

      <div style={s.deviceFrame}>
        <iframe
          key={reloadKey}
          title="Landing preview"
          src={src}
          style={{ ...s.iframe, width: dev.width, height: '100%' }}
          sandbox="allow-same-origin allow-scripts allow-forms"
        />
      </div>
    </div>
  );
}

const s = {
  wrap:        { margin: '-28px -40px -40px', padding: 0, color: 'var(--text-primary)', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 53px)' },
  toolbar:     { display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', padding: '10px 12px', borderBottom: '1px solid var(--border)', background: 'var(--surface)' },
  toolbarGroup:{ display: 'inline-flex', background: 'var(--surface-strong)', border: '1px solid var(--border)', borderRadius: '12px', padding: '4px' },
  pill:        { background: 'transparent', border: 'none', color: 'var(--text-secondary)', padding: '6px 14px', borderRadius: '8px', fontWeight: 600, fontSize: '13px', cursor: 'pointer' },
  pillActive:  { background: 'var(--accent)', color: '#fff' },
  refreshBtn:  { display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'var(--surface-strong)', border: '1px solid var(--border)', borderRadius: '10px', color: 'var(--text-primary)', padding: '8px 14px', fontWeight: 600, fontSize: '13px', cursor: 'pointer', textDecoration: 'none' },
  deviceFrame: { flex: 1, display: 'flex', justifyContent: 'center', background: 'var(--surface)', overflow: 'hidden', minHeight: 0 },
  iframe:      { border: 'none', background: '#fff', display: 'block' },
};
